__webpack_require__.p = "/collectiq/";